/* SALVE / THE GOOD MANUAL: motion.
   Adds html.gm-js, tags elements for scroll reveals, marks them .gm-in
   as they come on screen, and lets Bawa change expression on hover or
   tap. Styles live in salve-good-manual-motion.css. Does nothing for
   people who prefer reduced motion beyond showing everything. */
(function () {
  if (window.__gmMotion) return;
  window.__gmMotion = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('gm-js');

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var scopes = document.querySelectorAll('.gm');
    if (!scopes.length) return;

    /* Things that rise into place, in groups so each group staggers. */
    var REVEAL_GROUPS = [
      '.gm-lead', '.gm-grid > .gm-card', '.gm-more__grid > .gm-card', '.gm-home__cards', '.gm-judge > li', '.gm-notes > li', '.gm-fr > *',
      '.gm-issue__grp', '.gm-legend > div', '.gm-annot', '.gm-table tbody tr',
      '.gm-bigtype', '.gm-buy', '.gm-home__strip > a', '.gm-prod', '.gm-close__salve',
      '.gm-hub__promise > p', '.gm-art__dek', '.gm-aside'
    ];
    /* Things that animate themselves once seen (marks, notes, stickers...). */
    var SELF = [
      '.gm-mark', '.gm-note', '.gm-hand', '.gm-sticker', '.gm-stamp',
      '.gm-says', '.gm-masthead', '.gm-hub__five'
    ];

    var watch = [];
    /* Clipped elements (notes being written on) have no visible area,
       so the observer cannot see them. Watch their parent instead. */
    var CLIPPED = /(^|\s)(gm-note|gm-hand)(\s|$)/;
    var proxyFor = new Map();
    scopes.forEach(function (scope) {
      REVEAL_GROUPS.forEach(function (sel) {
        var els = scope.querySelectorAll(sel);
        els.forEach(function (el, i) {
          if (el.hasAttribute('data-gm-reveal')) return;
          el.setAttribute('data-gm-reveal', '');
          el.style.setProperty('--gm-i', String(i % 6));
          watch.push(el);
        });
      });
      SELF.forEach(function (sel) {
        scope.querySelectorAll(sel).forEach(function (el) {
          /* Stagger siblings of the same kind inside one parent. */
          var sibs = el.parentElement ? el.parentElement.querySelectorAll(':scope > ' + sel.replace(/^\./, '.')) : [];
          var idx = Array.prototype.indexOf.call(sibs, el);
          if (idx > 0) el.style.setProperty('--gm-i', String(idx % 6));
          if (CLIPPED.test(el.className) && el.parentElement) {
            var host = el.parentElement;
            if (!proxyFor.has(host)) { proxyFor.set(host, []); watch.push(host); }
            proxyFor.get(host).push(el);
          } else {
            watch.push(el);
          }
        });
      });
    });

    function show(el) {
      el.classList.add('gm-in');
      var kids = proxyFor.get(el);
      if (kids) kids.forEach(function (k) { k.classList.add('gm-in'); });
    }

    if (reduce || !('IntersectionObserver' in window)) {
      watch.forEach(show);
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      watch.forEach(function (el) { io.observe(el); });
      /* Safety net: never leave anything hidden if an observer misses it. */
      setTimeout(function () {
        watch.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) show(el);
        });
      }, 2500);
    }

    /* Bawa changes expression on hover (desktop) or tap (phone). */
    document.querySelectorAll('.gm img.gm-man[data-swap]').forEach(function (img) {
      var base = img.getAttribute('src');
      var alt = img.getAttribute('data-swap');
      var pre = new Image(); pre.src = alt;
      function on() { img.src = alt; img.classList.add('gm-man--swapped'); }
      function off() { img.src = base; img.classList.remove('gm-man--swapped'); }
      /* A mouse swaps on hover. A finger swaps on tap. Telling them apart
         matters: a tap also fires a hover first, which would otherwise
         swap and then immediately swap back. */
      var lastPointer = 'mouse';
      img.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
      img.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') on(); });
      img.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') off(); });
      img.addEventListener('click', function (e) {
        if (lastPointer === 'mouse') return;        /* hover already handled it */
        if (img.closest('a')) return;               /* inside a card: let the link work */
        e.preventDefault();
        if (img.classList.contains('gm-man--swapped')) off(); else on();
      });
    });

    /* After the entrance stamp, mark it settled so hover or spin ending
       does not replay the stamp. */
    document.querySelectorAll('.gm .gm-mark, .gm .gm-sticker').forEach(function (el) {
      el.addEventListener('animationend', function (e) {
        if (e.target === el && e.animationName === 'gm-stamp') el.classList.add('gm-settled');
      });
    });

    /* Tap the issue sticker on a phone and it spins. */
    document.querySelectorAll('.gm .gm-sticker').forEach(function (s) {
      s.addEventListener('click', function () {
        s.classList.remove('gm-spun'); void s.offsetWidth; s.classList.add('gm-spun');
        setTimeout(function () { s.classList.remove('gm-spun'); }, 900);
      });
    });
  });
})();
